import { jsx as _jsx } from "react/jsx-runtime";
import { MobileBottomSheetContext } from '#pplx/frontend/aether/components/internal/menu/useMobileBottomSheetContext.js';
/**
 * Provider that manages mobile bottom sheet state.
 */
export function MobileBottomSheetProvider({ children, close, }) {
    const contextValue = {
        close,
    };
    return (_jsx(MobileBottomSheetContext.Provider, { value: contextValue, children: children }));
}
//# sourceMappingURL=MobileBottomSheetContext.js.map